import { httpRequest } from "@services/http";

export class CommandRemoveUserFromOrg {
  async run(profileId: number, orgId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/profiles/${profileId}/organizations/${orgId}`;
    try {
      await httpRequest(url, { method: "DELETE" });
    } catch (error) {
      console.error("Error removing user from org:", error);
      throw error;
    }
  }
}
